import { render, staticRenderFns } from "./FirstBirthdaySetting.vue?vue&type=template&id=7e835b16&scoped=true&"
import script from "./FirstBirthdaySetting.vue?vue&type=script&lang=js&"
export * from "./FirstBirthdaySetting.vue?vue&type=script&lang=js&"
import style0 from "./FirstBirthdaySetting.vue?vue&type=style&index=0&id=7e835b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e835b16",
  null
  
)

export default component.exports